import { useQuery } from '@tanstack/react-query';

import { queries } from '../../../../common/api/queryKeys/queries';
import { OfferModel } from '../../../model/OfferModel';

export const useOfferValidation = (offer: OfferModel, enabled: boolean) => {
    const queryOptions = queries.offers.validation({ offerId: offer.id, offer: offer });
    return useQuery({ ...queryOptions, enabled });
};
